export enum TipoAtividade {
  COMPROMISSO = 'COMPROMISSO',
  TELEFONEMA = 'TELEFONEMA',
  REUNIAO_PRESENCIAL = 'REUNIAO_PRESENCIAL',
  REUNIAO_ONLINE = 'REUNIAO_ONLINE',
  EMAIL = 'EMAIL',
  OUTROS = 'OUTROS',
  WHATSAPP = 'WHATSAPP',
  OPORTUNIDADE = 'OPORTUNIDADE',
  PROCESSO = 'PROCESSO',
  FATURAMENTO = 'FATURAMENTO',
  ADMINISTRATIVO = 'ADMINISTRATIVO',
  APROVACAO_REQUISITO = 'APROVACAO_REQUISITO',
  APROVACAO_DESPESA = 'APROVACAO_DESPESA',
}
